/**
 * Tests if image URLs loads or if need to fallback to data URL images.
 * @param {String} url
 * @returns {Promise}
 */
export function testImageUrl(url) {
  return new Promise<string>(function (resolve, reject) {
    const image = new Image();
    image.addEventListener('load', () => resolve(url));
    image.addEventListener('error', () => reject(new Error(`Failed to load image: ${url}`)));
    if (!url) {
      reject(new Error(`Unknown url: ${url}`));
    }
    image.src = url;
  });
}
